import React from 'react';
import { Modal, Button } from '../common';
import { CharacterAspects } from './CharacterAspects';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const getMediaUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('/uploads/')) {
    return `${API_URL}${url}`;
  }
  return url;
};

export const CharacterViewModal = ({
  isOpen,
  onClose,
  character,
  onEdit,
  canEdit = false,
}) => {
  if (!character) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={character.name}
      size="lg"
    >
      <div className="space-y-6">
        {/* Character Image */}
        <div className="flex flex-col md:flex-row gap-6">
          <div className="md:w-1/3">
            {character.imageUrl ? (
              <img
                src={getMediaUrl(character.imageUrl)}
                alt={character.name}
                className="w-full aspect-square object-cover rounded-lg shadow-md"
              />
            ) : (
              <div className="w-full aspect-square bg-gray-100 rounded-lg flex items-center justify-center">
                <span className="text-6xl text-gray-400 font-medium">
                  {character.name?.[0]?.toUpperCase()}
                </span>
              </div>
            )}
          </div>

          <div className="md:w-2/3 space-y-4">
            {/* Description */}
            {character.description ? (
              <div>
                <h3 className="text-sm font-medium text-gray-500 mb-1">Description</h3>
                <p className="text-gray-900 whitespace-pre-wrap">{character.description}</p>
              </div>
            ) : (
              <p className="text-gray-500 italic">No description provided.</p>
            )}

            {/* Aspects */}
            <div>
              <CharacterAspects
                aspects={character.aspects || []}
                canEdit={false}
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 pt-4 border-t">
          {canEdit && onEdit && (
            <Button
              variant="secondary"
              onClick={() => {
                onClose();
                onEdit(character);
              }}
            >
              Edit Character
            </Button>
          )}
          <Button onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};
